import { render, staticRenderFns } from "./VStepsIndicator.vue?vue&type=template&id=09dbb271&scoped=true&"
import script from "./VStepsIndicator.vue?vue&type=script&lang=js&"
export * from "./VStepsIndicator.vue?vue&type=script&lang=js&"
import style0 from "./VStepsIndicator.vue?vue&type=style&index=0&id=09dbb271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dbb271",
  null
  
)

export default component.exports